export default {"src":"/_next/static/media/doctor_m_logo.a28f4ddb.svg","height":28,"width":195,"blurWidth":0,"blurHeight":0};